"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFinancialObjectiveTrads = void 0;
exports.EFinancialObjectiveTrads = {
    diversification: "Diversification",
    retirement_planning: "Préparation retraite",
    complementary_income: "Complément de revenus",
    portfolio_growth: "Valorisation d'un portefeuille",
    tax_optimization: "Optimisation fiscale",
};
